export default "__VITE_ASSET__D84HdNE0__"